/* eslint-disable import/no-extraneous-dependencies */
import { useState, useContext, useEffect } from 'react';
import _ from "lodash";
import moment from "moment";


import AppStateContext from '../app/context/appStateContext';
import JobListContext from '../app/context/jobListContext';
import filterHelper from "./useFilterHelper";

import PlannedJob from "../app/interfaces/plannedJob";

const usePlannedFilterForm = () => {
  const { contractList, selectedCustomerId } = useContext(AppStateContext);
  const { plannedJobList, filtersPlanned, updatePlannedFilters, updateFilteredPlannedJobList } = useContext(JobListContext);

  const { getDatePeriod } = filterHelper();

  const initialiseFilters =(defaultFilter: {}, filter: [] | string) => {
    let newState = _.cloneDeep(defaultFilter);

    if(_.isArray(filter)) {
      filter.map(filterCriteria => {
        newState[filterCriteria] = true;
      });
    } else {
      newState = filter;
    }

    return newState;
  };

  const [buildingFilter, setBuildingFilter] = useState({});
  const [ periodFilter, setPeriodFilter ] = useState('');
  const [ dateFilter, setDateFilter ] = useState(filtersPlanned.dateFilter);
  const [maintenanceTypeTabFilters, setMaintenanceTypeTabFilters] = useState(() => initialiseFilters('',filtersPlanned.maintenanceFilter));
  const [statusTabFilters, setStatusTabFilters] = useState(() => initialiseFilters('',filtersPlanned.statusFilter));

  useEffect(() => {
    let buildings = {};
    Object.keys(contractList[selectedCustomerId]).map((item,index) => {
      buildings[item] = false;
    });
    setBuildingFilter(buildings);
  },[]);

  const handleSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
    }
    let buildingKeys = _.keys(_.pickBy(buildingFilter));

    updatePlannedFilters({
      maintenanceFilter: maintenanceTypeTabFilters,
      statusFilter: statusTabFilters,
      buildingFilter: buildingFilter,
      dateFilter: dateFilter,
      periodFilter: periodFilter,
    });

    if(maintenanceTypeTabFilters != '' || statusTabFilters != '' || buildingKeys.length) {
      let allDate = true;


      updateFilteredPlannedJobList(
        plannedJobList.filter(job => {

          if(periodFilter != '' || dateFilter != undefined && Object.keys(dateFilter).length) {
            allDate = (periodFilter != '' && moment(job.RunDueDate, 'YYYY-MM-DD').isBetween(getDatePeriod(periodFilter).startDate, getDatePeriod(periodFilter).endDate, 'day','[]')) ||
              (dateFilter != undefined && Object.keys(dateFilter).length && moment(job.RunDueDate,'YYYY-MM-DD').isBetween(dateFilter.startDate, dateFilter.endDate,'day','[]'));
          } else {
            allDate = true;
          }

          let finalBoolean = true;

          if(maintenanceTypeTabFilters != '') finalBoolean = (finalBoolean && maintenanceTypeTabFilters == job.RoutineCode);

          if(statusTabFilters != '') finalBoolean = finalBoolean && (job.Status == 'Completed' && statusTabFilters == "completed" ||
            job.Status == 'Open' && statusTabFilters == "open" ||
            job.Status == 'Incomplete' && statusTabFilters == "incomplete");

          if(buildingKeys.length) finalBoolean = finalBoolean && buildingKeys.includes(job.ContractNo);

          return finalBoolean && allDate;
        })
      )
    } else if(periodFilter != '' || dateFilter != undefined && Object.keys(dateFilter).length) {
      updateFilteredPlannedJobList(
        plannedJobList.filter( (job: PlannedJob) => {
          let finalBoolean = true;

          if(periodFilter != '') finalBoolean = finalBoolean && moment(job.RunDueDate, 'YYYY-MM-DD').isBetween(getDatePeriod(periodFilter).startDate, getDatePeriod(periodFilter).endDate, undefined,'[]');
          if (Object.keys(dateFilter).length) finalBoolean = finalBoolean && moment(job.RunDueDate,'YYYY-MM-DD').isBetween(dateFilter.startDate, dateFilter.endDate, undefined,'[]');

          return finalBoolean
        })
      )
    } else {
      updateFilteredPlannedJobList(plannedJobList);
    }
  };

  const handleBuildingChange = (element: string) => {
    setBuildingFilter(prevState => {
      const newState = {...prevState};

      let newBuilding = {};
      newBuilding[element] = !newState[element];
      return _.merge(newState, newBuilding);
    })
  };

  const handleMaintenanceTypeChange = (event: any) => {
    event.persist();

    if(maintenanceTypeTabFilters == event.target.value ) setMaintenanceTypeTabFilters('');
    else setMaintenanceTypeTabFilters(event.target.value);
  };

  const handleStatusChange = (event: any) => {
    event.persist();

    if(event.target.value == statusTabFilters) setStatusTabFilters('');
    else setStatusTabFilters(event.target.value);
  };

  const handleDateChange = (newDates: {startDate: moment.Moment, endDate: moment.Moment}) => {
    let newStartDate = dateFilter.startDate;
    let newEndDate = dateFilter.endDate;
    if(newDates.startDate) {
      newStartDate = newDates.startDate.startOf('day');
    }
    if(newDates.endDate) {
      newEndDate = newDates.endDate.startOf('day')
    }

    setDateFilter({startDate: newStartDate, endDate: newEndDate});
    setPeriodFilter('');
  };

  const handlePeriodChange = (event: any) => {
    setDateFilter({});

    if(periodFilter == event.target.value) setPeriodFilter('');
    else setPeriodFilter(event.target.value)
  };

  const clearAllFilters = (event: any) => {
    event.persist();
    setPeriodFilter('');

    setDateFilter({});

    setMaintenanceTypeTabFilters('');

    setStatusTabFilters('');

    setBuildingFilter({});
  };

  return {
    buildingFilter,
    maintenanceTypeTabFilters,
    statusTabFilters,
    periodFilter,
    dateFilter,
    handleSubmit,
    handleBuildingChange,
    handleMaintenanceTypeChange,
    handleStatusChange,
    handleDateChange,
    handlePeriodChange,
    clearAllFilters,
  };
};

export default usePlannedFilterForm;
